import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  sidebarIsOpen = false;
  userMenuIsOpen = false;
  loaderIsVisible = false;
  userMenuIsOpenObservable: EventEmitter<boolean> = new EventEmitter<boolean>(
    false,
  );

  closeSidebar(): void {
    if (this.sidebarIsOpen) {
      this.sidebarIsOpen = false;
    }
  }

  closeUserMenu(): void {
    if (this.userMenuIsOpen) {
      this.userMenuIsOpen = false;
      this.userMenuIsOpenObservable.emit(this.userMenuIsOpen);
    }
  }

  toggleUserMenu(): void {
    this.closeSidebar();
    this.userMenuIsOpen = !this.userMenuIsOpen;
    this.userMenuIsOpenObservable.emit(this.userMenuIsOpen);
  }

  closeAll(): void {
    this.closeSidebar();
    this.closeUserMenu();
  }

  showLoader(): void {
    if (!this.loaderIsVisible) {
      this.loaderIsVisible = true;
    }
  }

  hideLoader(): void {
    if (this.loaderIsVisible) {
      this.loaderIsVisible = false;
    }
  }
}
